export enum ActionState {
    Initial = 'initial',
    InProgress = 'inProgress',
    Completed = 'completed'
}
